import {subdebug} from '@sanity/cli-core'

export const versionsDebug = subdebug('versions')
